<script>
import appConfig from '@src/app.config'
import PersonasLayout from '@layouts/ma.vue'
import Tabs from '@components/tabs/tabs.vue'
import AppStream from '@components/app-stream/app-stream.vue'

export default {
  page: {
    title: 'Research',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PersonasLayout, Tabs, AppStream },
}
</script>

<template>
  <PersonasLayout>
    <div id="personas--container" class="ant-row">
      <div id="tabs--container" class="ant-col-8">
        <Tabs />
      </div>
      <div id="app-stream--container" class="ant-col-16">
        <AppStream />
      </div>
    </div>
  </PersonasLayout>
</template>
